const objWall = {
  brkey: "",
  archForms: "",
  backFillMaterial1: "",
  backFillMaterial2: "",
  backfillSlope: null,
  beginCounty: "",
  beginOffset: "",
  beginRouteNum: "",
  beginSegNum: "",
  endCounty: "",
  endOffset: "",
  endRouteNum: "",
  endSegNum: "",
  fci: null,
  foundType: "",
  histElig: "",
  installRoadwayType: "",
  manufacturer: "",
  maxHeight: null,
  minClearance: null,
  minHeight: null,
  updateDateTime: "",
  mountType: "",
  postType: "",
  rebarType: "",
  roadDistance: null,
  roadSide: "",
  supportDesc: "",
  updateUserId: "",
  wallSurfaceArea: null,
  wallUse: "",
};

const objWallInsp = {
  brkey: "",
  inspectionId: "",
  anchorageCondRate: "",
  backfillCondRate: "",
  drainageCondRate: "",
  foundCondRate: "",
  updateDateTime: "",
  nextWallInspType: "",
  panelCondRate: "",
  parapetsCondRate: "",
  postCondRate: "",
  strRating: "",
  updateUserId: "",
  wallCondRate: "",
  wallInspType: "",
};

export { objWallInsp, objWall };
